import { ArrowLeft, MapPin, Calendar, Users, Plane, Hotel, Utensils, Waves, Anchor, Turtle, Camera, Sunset } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ZANZIBAR_IMAGES = {
  day1: 'https://images.pexels.com/photos/14756121/pexels-photo-14756121.jpeg',
  day2: 'https://images.pexels.com/photos/36468248/pexels-photo-36468248.jpeg',
  day3: 'https://images.unsplash.com/photo-1531413260055-c474aa3ee74d',
  day4: 'https://images.pexels.com/photos/38521984/pexels-photo-38521984.jpeg',
};

export default function Zanzibar() {
  const navigate = useNavigate();

  const days = [
    { day: 1, title: 'Stone Town: Patrimônio da Humanidade', description: 'Bem-vindo ao coração histórico de Zanzibar',
      highlights: [
        { icon: Plane, title: 'Boas-vindas VIP', description: 'Chegada ao aeroporto seguida de transfer privado para seu hotel. Check-in e tempo para relaxar antes da primeira imersão na ilha.' },
        { icon: MapPin, title: 'Imersão em Stone Town', description: 'Passeio guiado pelo labirinto de ruelas históricas, visitando o antigo mercado e descobrindo a arquitetura única de influências árabes e indianas.' },
        { icon: Utensils, title: 'Sabores de Zanzibar', description: 'Noite livre para desfrutar de um jantar típico em um dos charmosos restaurantes locais, experimentando a rica fusão de especiarias da ilha.' },
      ],
      quote: 'Stone Town é um portal para o passado, onde cada rua conta uma história de comércio, cultura e tradição milenar.' },
    { day: 2, title: 'Nungwi Beach', description: 'Praias de areia branca e águas turquesas',
      highlights: [
        { icon: Waves, title: 'Mar Azul Turquesa', description: 'Desfrute de um dia inteiro nas areias brancas de Nungwi, onde o mar exibe tons de azul impossíveis de descrever.' },
        { icon: Anchor, title: 'Aventura Aquática', description: 'Atividade opcional de mergulho para explorar os recifes de corais vibrantes e a vida marinha abundante.' },
        { icon: Sunset, title: 'Pôr do Sol Mágico', description: 'Contemple o entardecer mais famoso de Zanzibar, com o céu se transformando em uma paleta de cores quentes sobre o Índico.' },
      ],
      quote: 'Nungwi é o paraíso tropical que você sempre sonhou, com águas cristalinas e praias intocadas.' },
    { day: 3, title: 'Prison Island & Gigantes', description: 'Encontro com tartarugas centenárias',
      highlights: [
        { icon: Anchor, title: 'Travessia em Dhow', description: 'Embarque em um barco tradicional de madeira para uma navegação suave pelas águas cristalinas até a histórica Ilha Prisão.' },
        { icon: Turtle, title: 'Gigantes Centenárias', description: 'Encontro inesquecível com as tartarugas gigantes de Aldabra, algumas com mais de 150 anos de idade, em seu santuário natural.' },
        { icon: Waves, title: 'Tarde de Relax', description: 'Retorno para o hotel e tarde livre para desfrutar do spa ou simplesmente contemplar a paz da ilha.' },
      ],
      quote: 'Prison Island oferece uma conexão única com a natureza e a história.' },
    { day: 4, title: 'Relaxamento & Retorno', description: 'Encerramento da jornada paradisíaca',
      highlights: [
        { icon: Waves, title: 'Manhã Livre', description: 'Aproveite os últimos momentos na praia ou na piscina do resort. Tempo para fotos e descanso final.' },
        { icon: Plane, title: 'Transfer Privado', description: 'Transfer para o aeroporto internacional de Zanzibar, garantindo conforto e pontualidade para o seu embarque.' },
        { icon: Camera, title: 'Embarque de Retorno', description: 'Retorne com a alma renovada pelas águas turquesas e a cultura vibrante da ilha das especiarias.' },
      ],
      quote: 'Encerre sua jornada paradisíaca com a certeza de ter vivido experiências que durarão para sempre.' },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <div className="relative h-96 md:h-[500px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1483683804023-6ccdb62f86ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHx6YW56aWJhciUyMGJlYWNofGVufDB8fHx8MTc4NDgyODIwMHww&ixlib=rb-4.1.0&q=85" alt="Zanzibar" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-4">ROTEIRO ZANZIBAR</h1>
          <p className="text-xl md:text-2xl text-white/90 text-center">O Caribe da África</p>
        </div>
      </div>

      <div className="container py-6">
        <button onClick={() => navigate('/#destinations')} className="flex items-center gap-2 text-primary hover:text-accent font-semibold transition-colors">
          <ArrowLeft size={20} /> Voltar aos Destinos
        </button>
      </div>

      <div className="container py-12">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-muted-foreground text-lg leading-relaxed mb-8">
            Uma experiência paradisíaca de 4 dias nas ilhas de Zanzibar, onde praias de areia branca, águas turquesas e cultura vibrante se encontram. Explore Stone Town, relaxe em Nungwi Beach e encontre tartarugas gigantes centenárias em Prison Island.
          </p>
          <div className="grid grid-cols-3 gap-6 md:gap-8">
            <div className="flex flex-col items-center"><Calendar className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">4 Dias</p></div>
            <div className="flex flex-col items-center"><Users className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">A partir de 1 pessoa</p></div>
            <div className="flex flex-col items-center"><Plane className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">Tudo Incluído</p></div>
          </div>
        </div>
      </div>

      <div className="container py-12 flex-1">
        <h2 className="text-4xl font-bold text-center text-primary mb-16">SEU CRONOGRAMA PARADISÍACO</h2>
        <div className="space-y-16">
          {days.map((dayInfo, index) => (
            <div key={index} className="flex flex-col md:flex-row gap-8 items-stretch fade-in-up" style={{ animationDelay: `${index * 80}ms` }}>
              <div className="md:w-1/2">
                <img src={ZANZIBAR_IMAGES[`day${dayInfo.day}`]} alt={dayInfo.title} className="w-full h-80 object-cover rounded-lg shadow-lg hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="md:w-1/2 flex flex-col justify-center">
                <div className="mb-4">
                  <span className="text-accent font-bold text-sm">DIA {dayInfo.day}</span>
                  <h3 className="text-3xl font-bold text-primary mt-2">{dayInfo.title}</h3>
                  <p className="text-muted-foreground mt-1">{dayInfo.description}</p>
                </div>
                <div className="space-y-4 mb-6">
                  {dayInfo.highlights.map((h, idx) => {
                    const Icon = h.icon;
                    return (
                      <div key={idx} className="flex gap-3">
                        <Icon className="text-accent flex-shrink-0" size={24} />
                        <div>
                          <p className="font-semibold text-primary">{h.title}</p>
                          <p className="text-muted-foreground text-sm">{h.description}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <blockquote className="border-l-4 border-accent pl-4 py-2 italic text-muted-foreground">“{dayInfo.quote}”</blockquote>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-slate-50 py-12 mt-16">
        <div className="container">
          <h2 className="text-3xl font-bold text-primary mb-8">O QUE ESTÁ INCLUÍDO</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex gap-4"><Hotel className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Hospedagem Premium</h3><p className="text-muted-foreground">Resorts 5 estrelas em localizações paradisíacas</p></div></div>
            <div className="flex gap-4"><Plane className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Transferências Privadas</h3><p className="text-muted-foreground">Todos os transportes em veículos premium</p></div></div>
            <div className="flex gap-4"><Anchor className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Passeios & Atividades</h3><p className="text-muted-foreground">Todas as experiências conforme descrito no roteiro</p></div></div>
            <div className="flex gap-4"><Utensils className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Refeições Gourmet</h3><p className="text-muted-foreground">Café da manhã, almoço e jantar em restaurantes premium</p></div></div>
          </div>
        </div>
      </div>

      <div className="container py-12">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-primary mb-4">Pronto para Viver Esta Experiência?</h2>
          <p className="text-muted-foreground mb-8">Entre em contato conosco e customize seu roteiro</p>
          <a href="https://wa.me/5548991904829?text=Olá! Gostaria de orçar o roteiro premium de Zanzibar." target="_blank" rel="noopener noreferrer" className="btn-primary inline-block no-underline">
            Solicitar Orçamento via WhatsApp
          </a>
        </div>
      </div>

      <div className="bg-primary text-white py-8 mt-8">
        <div className="container text-center">
          <p className="font-semibold mb-2">PROPOSTA EXCLUSIVA | 2026</p>
          <p>@jmtravel.oficial | CNPJ 64.418.580/0001-14</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
